<template >
  <div v-loading="showFlag">
    <!--  ミスミ配送単出力選択画面 -->
    <t-card>
      <div
        :style="{
          height: basicHeight + 'px',
          'padding-top': '10px',
          'padding-bottom': '10px',
        }"
      >
        <t-form :model="selectReceiveForm" label-position="right">
          <t-row class="col_common_center">
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
              >&nbsp;</t-col
            >
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHTEEN'))"
            >
              <!-- ミスミ大連 -->
              <t-radio
                v-model="selectReceiveForm.misumiKbn"
                :label="5"
                style="line-height: 3; width: 40%"
                >{{ $t("resource.ORDER.MISUMI_DL") }}</t-radio
              >
              <!-- ミスミ大連以外 -->
              <t-radio
                v-model="selectReceiveForm.misumiKbn"
                :label="1"
                style="line-height: 3; width: 40%"
                >{{ $t("resource.ORDER.MISUMI_NOT_DL") }}</t-radio
              >
            </t-col>

            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="right"
            >
              <!-- 確定 -->
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="ConfirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
              >&nbsp;</t-col
            >
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { outputExcelToZip } from "@/services/common";
import { DIALOG_LINE_HEIGHT, NUM_ONE, NUM_TWO } from "@/utils/const";

import { ref } from "vue";
export default {
  data() {
    return {
      //検索条件
      selectReceiveForm: {
        misumiKbn: "", // ミスミ区分
      },

      //待ちダイアログ
      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    dataList: {
      Type: Object,
      default: null,
    },
  },
  mounted() {
    // 初期化
    this.init();
  },

  methods: {
    // 初期化
    init() {
      // 編集の場合
      if (!!this.isAdd) {
        // 新規の場合、チェックボックスは「ミスミ大連」が選択
        this.selectReceiveForm.misumiKbn = ref(5);
      }
    },

    //确定ボタン
    ConfirmClick() {
      if (!!this.selectReceiveForm.misumiKbn) {
        this.showFlag = true;

        let outPutData = {
          misumiKbn: this.selectReceiveForm.misumiKbn,
          outPutList: this.dataList,
        };

        //配送単出力
        outputExcelToZip(httpApi.OutPutDeliveryOrder, outPutData).finally(
          () => {
            this.showFlag = false;
            this.Close();
          }
        );
      }
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
</style>
